import { Pipe, PipeTransform } from '@angular/core';
import { Lang } from './language.service';

/**
 * Picks the right language value. Pass the current language as the third arg so
 * the pipe stays pure and re-evaluates when the language toggles.
 *   {{ post.titleEn | loc : post.titleAr : lang }}
 */
@Pipe({ name: 'loc' })
export class LocalizePipe implements PipeTransform {
  transform(en: string | null | undefined, ar: string | null | undefined, lang: Lang | null): string {
    if (lang === 'ar') return (ar && ar.trim().length ? ar : en) ?? '';
    return (en && en.trim().length ? en : ar) ?? '';
  }
}
